<template>
  <div class="base-loading">
    <div class="base-loading-icon">
      <i class="fa-solid fa-spinner fa-spin"></i>
    </div>
  </div>
</template>